module.exports = __webpack_public_path__ + "img/email--white.651bc611.svg";